import React from 'react'
import CustomTable from '../../../../elements/Table/CustomTable'
import checkboxHOC from 'react-table-v6/lib/hoc/selectTable'
import { Button } from 'antd'
import DateCell from '../../../../elements/Table/Cells/DateCell'
import MoneyCell from '../../../../elements/Table/Cells/MoneyCell'

const CheckboxTable = checkboxHOC(CustomTable)

function List(props) {
  const { list, fetch, selectAll, isSelected, toggleSelection, toggleAll, fetching, tableRef, onShow } = props
  const checkboxProps = {
    selectType: 'checkbox',
    selectAll,
    isSelected,
    toggleSelection,
    toggleAll,
  }
  const columns = [
    {
      Header: 'System ID',
      accessor: '_key',
      Cell: ({ value, original }) => <a onClick={() => onShow(original, 'edit')}>{value}</a>,
    },
    { Header: 'Vendor', accessor: 'vendor.name', width: 200, hideable: true },
    { Header: 'Start date', accessor: 'date.start', Cell: DateCell },
    { Header: 'End date', accessor: 'date.end', Cell: DateCell },
    { Header: 'Make', accessor: 'make' },
    { Header: 'Type', accessor: 'vehicleType' },
    { Header: 'Model', accessor: 'model' },
    { Header: 'Year', accessor: 'year', hideable: true, hideDefault: true },
    { Header: 'Details', accessor: 'details', hideable: true, hideDefault: true },
    { Header: 'Plate', accessor: 'plate', hideable: true, hideDefault: true },
    {
      Header: 'Reference',
      accessor: 'reference.no',
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'DriverName',
      accessor: 'driver.driverName',
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'DriverPhone',
      accessor: 'driver.driverPhone',
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'Amount',
      accessor: 'amount',
      Cell: MoneyCell,
      hideable: true,
    },
  ]

  return (
    <CheckboxTable
      {...checkboxProps}
      withRef={tableRef}
      data={list}
      isFilterable={true}
      fetching={fetching}
      fetch={fetch}
      CreateButton={() => (
        <Button type={'primary'} size="small" icon={'plus'} onClick={onShow}>
          New{' '}
        </Button>
      )}
      columns={columns}
      show={{ extraColumns: true }}
    />
  )
}

List.propTypes = {}
List.defaultProps = {}

export default List
